// extracted by mini-css-extract-plugin
export var projectCard = "project-module--projectCard--Av5CP";
export var projectCardImage = "project-module--projectCardImage--itqOS";
export var Image = "project-module--Image--UiG1d";
export var badgePromo = "project-module--badgePromo--9KY4l";
export var badgePromoInner = "project-module--badgePromoInner--rqSU-";
export var badgePromoContent = "project-module--badgePromoContent--w6BUg";
export var projectCardHeading = "project-module--projectCardHeading--Z24vc";